import styled from "styled-components";
import theme from "../common/theme";

export const P = styled.p`
    font-family: "Roboto Condensed", sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    color: ${theme.palette.text};
    margin: 0;
    padding: 0;
    user-select: none;
`;

export const Ph = styled(P)`
    color: #7E7E7E;
`;

export const CTAText = styled(P)`
    color: #A6A6A6;
    border-bottom: 2px solid #A6A6A6;
    font-weight: 700;
    font-size: 16px;
    margin-left: 5px;
`;

export const Pmb = styled(P)`
    font-family: "Roboto Condensed", sans-serif;
    font-weight: 700;
`;

export const Pp = styled(P)`
`;

export const Pf = styled(P)`
    font-weight: 700;
`;

export const P3 = styled(P)`
    color: #7e7e7e;
    font-weight: 700;
    font-size: 16px;
`;

export const Pb = styled(P)`
    font-size: 16px;
`;

export const P1 = styled(P)`
    font-weight: 700;
    font-size: 16px;
`;

export const P2 = styled(P)`
    font-weight: 700;
`;

export const H1 = styled.h1`
    font-family: Roboto Condensed;
    font-size: 35px;
    font-style: normal;
    font-weight: 400;
    margin: 0;
    padding: 0;
    letter-spacing: 1px;
    user-select: none;

`;

export const H2 = styled(H1)`
    font-size: 20px;
`;

